import { useParams } from 'react-router-dom';
import { Nav } from 'components/Navigation/NavLayout';
import { SUBROUTES_LINKS } from '../routes';

export const NavBar = () => {
  const { subpage } = useParams();
  return (
    <Nav.Container>
      <Nav.SubNavigationRow>
        {Object.entries(SUBROUTES_LINKS).map(([key, route], index, arr) => {
          return (
            <Nav.SubNavigationLink
              key={key}
              isLast={index === arr.length - 1}
              route={route}
              to={route.path}
              isActive={() => subpage === route.path}
            />
          );
        })}
      </Nav.SubNavigationRow>
    </Nav.Container>
  );
};
